import { render, staticRenderFns } from "./CarteirinhaComponent.vue?vue&type=template&id=5948105c&scoped=true"
import script from "./CarteirinhaComponent.vue?vue&type=script&lang=js"
export * from "./CarteirinhaComponent.vue?vue&type=script&lang=js"
import style0 from "./CarteirinhaComponent.vue?vue&type=style&index=0&id=5948105c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948105c",
  null
  
)

export default component.exports